import React from 'react';
import PropTypes from 'prop-types';
import PlaceholderDefaultIcon from './placeholder-default-icon';
import PlaceholderMenuIcon from './placeholder-menu-icon';
import PlaceholderPersonIcon from './placeholder-person-icon';
import PlaceholderTicketIcon from './placeholder-ticket-icon';
import PlaceholderToolboxIcon from './placeholder-toolbox-icon';

function getPlaceholderFor(type) {
  const iconMap = {
    team: PlaceholderPersonIcon,
    testimonials: PlaceholderPersonIcon,
    menu: PlaceholderMenuIcon,
    pricing: PlaceholderTicketIcon,
    products: PlaceholderTicketIcon,
    services: PlaceholderToolboxIcon,
  };

  return iconMap[type] || PlaceholderDefaultIcon;
}

function MediaPlaceholder({ type = null }) {
  const IconComponent = getPlaceholderFor(type);

  return (
    <div className="ws-media-placeholder">
      <IconComponent className="ws-media-placeholder__icon" />
    </div>
  );
}

MediaPlaceholder.propTypes = {
  type: PropTypes.string,
};

export default MediaPlaceholder;
